/* eslint-disable sort-keys */
const headerLinks = {
  online: [
    {
      href: '/future-students/programs/?c=online',
      state: { campus: '45' },
      text: 'Programs',
    },
    {
      href: '/campuses/online/',
      text: 'Online Experience',
    },
    {
      href: '/future-students/student-services/',
      text: 'Your Support Team',
    },
    {
      href: '/future-students/career-services/',
      text: 'Help Finding a Job',
    },
    {
      href: '/program-quiz/',
      text: 'Personality Quiz',
    },
    {
      href: '/students/uma-partner-schools/',
      text: 'Partner Schools',
    },
    {
      href: '/students/uma-reviews/',
      text: 'Reviews',
    },
  ],
  campus: [
    {
      href: '/future-students/programs/?c=clearwater',
      state: { campus: '47' },
      text: 'Programs',
    },
    {
      href: '/campuses/clearwater/',
      text: 'Campus Experience',
    },
    {
      href: '/campuses/clearwater/student-services/',
      text: 'Student Services',
    },
    {
      href: '/program-quiz/',
      text: 'Personality Quiz',
    },
    {
      href: '/students/uma-partner-schools/',
      text: 'Partner Schools',
    },
    {
      href: '/students/uma-reviews/',
      text: 'Reviews',
    },
  ],
  admissions: [
    {
      href: '/future-students/admissions/',
      text: 'UMA Admissions',
    },
    {
      href: '/future-students/tuition/',
      text: 'Tuition',
    },
    {
      href: '/future-students/financial-aid/',
      text: 'Financial Aid',
    },
    {
      href: '/future-students/transferring-credits/',
      text: 'Transferring Credits',
    },
    {
      href: '/future-students/disability-services/',
      text: 'Disability Services',
    },
    {
      href: '/future-students/military/',
      text: 'Military',
    },
  ],
  employerPartners: [
    {
      href: '/employers/',
      text: 'Hire UMA Grads',
    },
    {
      href: '/employers/positions-we-staff/',
      text: 'Positions We Staff',
    },
    {
      href: '/employers/our-graduates/',
      text: 'Our Graduates',
    },
    // {
    //   href: '/employers/our-team/',
    //   text: 'Our Team',
    // },
    {
      href: '/employers/industry-insights/',
      text: 'Industry Insights',
    },
    {
      href: '/certification-training/',
      text: 'Certification Training',
    },
  ],
  aboutUs: [
    {
      href: '/about/',
      text: 'About UMA',
    },
    {
      href: '/about/accreditation/',
      text: 'Accreditation',
    },
    {
      href: '/about/administration/',
      text: 'Administration',
    },
    {
      href: '/about/community-outreach/',
      text: 'Community Involvement',
    },
    {
      href: '/about/diversity-and-inclusion/',
      text: 'Diversity and Inclusion',
    },
    {
      href: '/about/newsroom/',
      text: 'Newsroom',
    },
    {
      href: '/about/continuing-medical-education/',
      text: 'Continuing Medical Education',
    },
    {
      href: '/blog/',
      text: 'UMA Blog',
    },
  ],
}

export default headerLinks
